import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

export default function ProductStateView(props) {
  const { t, i18n } = useTranslation("modals");
  const [open, setOpen] = useState(true);

  const renderOptions = (data) => {
    const retArray = [];
    data &&
      Object.entries(data).forEach(([key, value]) => {
        retArray.push(
          <option key={key} value={key}>
            {t("productstate.option_" + value)}
          </option>
        );
      });

    return retArray;
  };

  const saveEvent = (event) => {
    event.preventDefault();
    let data = {
      id: props.modalview.data.id,
      state: event.target.elements.stateSelector.value,
    };
    props.modalview.saveEvent(data);
  };

  const handleClose = () => {
    setOpen(false);
    if (props.onHideEvent) {
      props.onHideEvent();
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
          <div className="flex justify-center items-end p-4 min-h-full text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="overflow-hidden relative text-left bg-white shadow-xl transition-all transform sm:my-8 sm:w-full sm:max-w-lg">
                <form onSubmit={saveEvent}>
                  <div className="px-4 pt-5 pb-4 sm:p-6">
                    <div className="flex items-center">
                      <div className="flex flex-shrink-0 justify-center items-center mx-auto w-12 h-12 bg-blue-50 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="text-blue-600"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                          />
                        </svg>
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-lg font-medium leading-6 text-gray-900"
                        >
                          {props.modalview.header}
                        </Dialog.Title>
                      </div>
                    </div>

                    <div className="mt-4">
                      <p className="mb-6 text-sm text-gray-500">
                        {props.modalview.message}
                      </p>
                      <div className="mb-4">
                        <label
                          htmlFor="stateSelector"
                          className="block font-medium text-gray-900 text-sm/6"
                        >
                          {t("productstate.title")}
                        </label>
                        <div className="grid grid-cols-1 mt-2">
                          <select
                            id="stateSelector"
                            name="stateSelector"
                            className="col-start-1 row-start-1 py-1.5 pr-8 pl-3 w-full text-base text-gray-900 bg-white appearance-none outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
                          >
                            <option value="">Selecteer een status</option>
                            {renderOptions(props.modalview.data.nextState)}
                          </select>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="col-start-1 row-start-1 justify-self-end self-center mr-2 text-gray-500 pointer-events-none size-5 sm:size-4"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 9L12 17L4 9"
                              stroke="currentColor"
                              strokeWidth="2"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="gap-3 px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button type="submit" className="btn-primary">
                      Opslaan
                    </button>
                    <button
                      type="button"
                      className="btn-secondary"
                      onClick={handleClose}
                    >
                      Annuleren
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
